import JapaneseHolidays from 'japanese-holidays'

/**
 * @param {Date} date
 * @returns {Boolean}
 */
export const isHoliday = (date) => {
  return JapaneseHolidays.isHoliday(date)
}